import { z } from 'zod';
export const semanticFindingSeverities = [
    'info',
    'low',
    'medium',
    'high',
    'critical',
];
export const semanticFindingCategories = [
    'coupling',
    'runtime_safety',
    'orchestration',
    'security',
    'database',
    'concurrency',
    'dependency_drift',
    'api_contracts',
    'maintainability',
    'testability',
];
export const semanticFindingSeveritySchema = z.enum(semanticFindingSeverities);
export const semanticFindingCategorySchema = z.enum(semanticFindingCategories);
export const semanticFindingSchema = z.object({
    id: z.string().min(1),
    severity: semanticFindingSeveritySchema,
    category: semanticFindingCategorySchema,
    title: z.string().min(1).max(500),
    summary: z.string().min(1).max(4000),
    file_path: z.string().min(1),
    symbol: z.string().max(256).optional(),
    evidence: z.array(z.string()).default([]),
    remediation: z.string().max(4000).optional(),
    metadata: z.record(z.unknown()).optional(),
});
export const semanticDependencyEdgeSchema = z.object({
    from: z.string().min(1),
    to: z.string().min(1),
    type: z.enum([
        'imports',
        'dynamic_import',
        'runtime_reference',
        'database_dependency',
        'api_dependency',
    ]),
});
export const semanticAnalysisSummarySchema = z.object({
    scanned_files: z.number().int().min(0),
    scanned_symbols: z.number().int().min(0),
    findings: z.array(semanticFindingSchema),
    dependency_edges: z.array(semanticDependencyEdgeSchema),
    generated_at: z.coerce.date().default(() => new Date()),
});
export function parseSemanticFinding(input) {
    return semanticFindingSchema.parse(input);
}
export function parseSemanticAnalysisSummary(input) {
    return semanticAnalysisSummarySchema.parse(input);
}
//# sourceMappingURL=sync-semantic-analysis.js.map